const getStatus = (status) => {
  switch (status) {
    case 'ALL':
      return {
        showPriorities: [0, 2],
        status: ['DRAFT', 'PENDING', 'APPROVED', 'WITHDRAWN', 'OVERDUE'],
      };
    case 'ACTIVE':
      return {
        showPriorities: [0],
        status: ['DRAFT', 'PENDING', 'APPROVED', 'WITHDRAWN'],
      };
    case 'DRAFT':
    case 'PENDING':
      return { showPriorities: [0], status: [status] };
    case 'APPROVED':
    case 'WITHDRAWN':
      return { showPriorities: [0, 2], status: [status] };
    case 'OVERDUE':
      return { showPriorities: [2], status: ['DRAFT', 'PENDING'] };
    default:
      return {
        showPriorities: [0, 2],
        status: ['DRAFT', 'PENDING', 'APPROVED', 'WITHDRAWN', 'OVERDUE'],
      };
  }
};

export default getStatus;
